<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        >
            <v-card
                class="mt-7"
                width="500"
                flat
                outlined
                rounded="xl"
            >  
            
                <v-toolbar 
                    flat
                >
                    <v-toolbar-title>Term Reports</v-toolbar-title>  
                </v-toolbar>

                <v-card
                    flat
                    class="pa-3"
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        fixed-header
                        height="50vh"
                        class="custom-table"
                    >
                        <template v-slot:item="{ item }">
                            <tr @click="displayReport(item)">
                                <td class="px-0">
                                    <div class="card">
                                        <div>{{ item.title }}</div>
                                        <div>{{ item.headline }}</div>
                                        <div>{{ item.subtitle }}</div>
                                    </div>
                                </td>
                                <td class="px-0">
                                    <div class="card d-flex flex-column justify-end">
                                        <span class="d-flex justify-end mb-2 text-caption" v-if="item.posted">Posted</span>
                                        <span class="d-flex justify-end text-caption" v-else>Not Posted</span>
                                        <span class="d-flex justify-end">
                                            <v-btn
                                                color="primary"
                                                outlined
                                                small
                                                @click="displayReport(item)"
                                                :disabled="!item.posted"
                                            >
                                                View Report
                                            </v-btn>
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
                
            </v-card>
        </v-row>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
        
        <PDFViewer 
            :fileSrc="src"
            :initialDialog="reportCard"
            :reportName="reportName"
            :downloadForm="true"
            @closeDialog="closeReport"
        />

        <v-dialog
            v-model="dialogError"
            max-width="320"
            persistent
            transition="dialog-transition"
        >
            <v-card class="error-card" rounded="lg">
            <v-card-text class="pt-6 pb-2 text-center">
                <v-avatar color="red lighten-5" size="64" class="mb-4">
                    <v-icon color="red darken-2" size="32">mdi-alert-circle-outline</v-icon>
                </v-avatar>

                <div class="text-h6 font-weight-bold mb-1">
                    {{ errorTitle }}
                </div>

                <div class="text-body-2 grey--text text--darken-1">
                    {{ errorMessage }}
                </div>

                <v-expand-transition v-if="errorDetails">
                    <div v-show="showDetails" class="error-details mt-3 text-left">
                        <pre class="text-caption mb-0">{{ details }}</pre>
                    </div>
                </v-expand-transition>

                <v-btn
                    v-if="errorDetails"
                    text
                    x-small
                    color="grey darken-1"
                    class="mt-1"
                    @click="showDetails = !showDetails"
                >
                    {{ showDetails ? 'Hide details' : 'Show details' }}
                </v-btn>
            </v-card-text>

            <v-card-actions class="pb-4 px-6 justify-center">
                <v-btn
                    color="red darken-2"
                    class="white--text"
                    depressed
                    @click="dialogError = false"
                    block
                >
                    Close
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
       
    </layout>    
</template>

<script>
import Layout from './layouts/App';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import PDFViewer from './PDFViewer';

export default {
    name: 'TermReport',
    components: {
        Layout,
        PDFViewer,
    },

    created(){
        this.initialize();
    },
    
    data: () => ({
        reportCard: false,
        selected: -1,
        items: [],
        src: '',
        overlay: false, 
        headers:[
            { text: 'Report', value: 'term', sortable: false },
            { text: '', value: 'action', sortable: false },
        ] ,
        loading: false, 
        reportName: '',
        dialogError: false, 
        errorTitle: '',
        errorMessage: '',
        errorDetails: '', 
        showDetails: false,  
    }),

    computed:{
        ...mapGetters({
            studentRecord: 'auth/getStudentRecord',
            reportTerms: 'report/getReportTerms'                    
        }),

        record(){
            return JSON.parse(this.studentRecord);
        },
    },
    methods: {
        ...mapActions({
            getAcademicTerms: 'report/getAcademicTerms',
        }),
        
        ...mapMutations({
            setOverlay: 'auth/setOverlay',
        }),

        displayReport(item){
            if(item.posted === false){
                this.errorMessage = 'This report has not been posted yet.'
                this.dialogError = true;
                return;     
            }      
            let term_id = item.term;
            let form_class_id = item.form_class_id;
            this.reportCard = true;
            this.reportName = 'Term Report';
            this.src = process.env.VUE_APP_API_URI + 
            `/api/report-card?academicTermId=${term_id}&` +
            `formClassId=${form_class_id}&`+
            `studentId=${this.record.id}&`+
            `userType=student`
        },

        async initialize(){
            this.overlay = true;
            await this.getAcademicTerms({ id: this.record.id });
            this.reportTerms.forEach(term => {
                if(term.posted){
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: true
                    })
                }
                else{
                    this.items.push({
                        title: 'Form ' + term.form_level,
                        action: term.term_end,
                        headline: 'End of Term Report',
                        subtitle: 'Term ' + term.term + ' ' + term.academic_year,
                        term: term.academic_term_id,
                        form_class_id: term.form_class_id,
                        posted: false
                    })
                }
               
            });
            this.overlay = false;
        },
        closeReport(){
            console.log('report closing ...');
            this.src = '';
            this.selected = -1;
            this.reportCard = false;
        }
    }
   
    
}
</script>

<style scoped>
    ::v-deep .v-list-item.v-list-item--disabled.v-list-item--link.theme--light {
        background: gainsboro;
    }

     ::v-deep .custom-table{
        border-collapse: separate;
        border-spacing: 0 14px;
    }

    ::v-deep .card{
        background: #faf6ef;
        padding: 14px;
        margin-top: 12px;
        margin-bottom: 12px;
        height: 80px;
    }

    td:first-child .card {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    td:last-child .card {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    ::v-deep .v-data-table .v-data-table__wrapper table tbody tr:hover{
        background: transparent !important;
        cursor: pointer;
        
    }

    .v-data-table .v-data-table__wrapper table tbody tr td{
        border-bottom: none !important;
    }
</style>